module.exports = __webpack_public_path__ + "layout_com8.jpg?17955d940d6f479d41ca2130394d77bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com8.jpg
// module id = 88
// module chunks = 0